import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import MiaBelovedApp from './MiaBelovedApp.jsx'
import './index.css'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <MiaBelovedApp />
  </StrictMode>,
)
